module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fm-titlea1",
    attrs: {
      "id": "som"
    }
  }, [_vm._v("Some Guidance Notes for the Reader")]), _vm._v(" "), _c('h4', {
    staticClass: "sub-sectionc",
    attrs: {
      "id": "lev_01"
    }
  }, [_vm._v("A NOTE ON SPANISH UNITS OF WEIGHTS AND MEASUREMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The authors had to think hard about the units of measurements in which we would report vessels’ dimensions. In pre-metrication Spain, there were a variety of units used, some only employed locally and other used for specific purposes. Early units were given names based on the nearest anatomical equivalents. For the period of this book, there were two distinct systems: the system which had been formally introduced back in 1590, and its replacement which came into force in 1750. We need to describe these two systems below and explain their equivalence in measures which the modern reader will understand, by comparing it with the metric units of measurement.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The system which prevailed from 1590 to 1750 used as its units of measurement the "), _c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("codo")])]), _vm._v(" (literally ‘elbow’) and the "), _c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("dedo")])]), _vm._v(" (literally ‘finger’). The difficulty is that there were varying interpretations of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("codo")]), _vm._v(". For many purposes, the standard "), _c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("codo")])]), _vm._v(" equated to approximately 418mm (about 16.55 UK/US inches). However, for the purpose of shipbuilding there was a specialised "), _c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("codo real de Castilla")])]), _vm._v(", which was a third longer than the standard "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("codo")]), _vm._v(" and thus contained 32 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("dedos")]), _vm._v(", thus roughly equivalent to 557.27mm (or slightly under 21.94 inches). However, also used in shipbuilding was the "), _c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("codo de ribera")])]), _vm._v(" (or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ribera cbica")]), _vm._v(") of 33 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("dedos")]), _vm._v(" (574.68468mm) which was first applied on the coast of the Cantabric Sea (‘Bay of Biscay’ to British mariners) and which from 1590 was generalised to all of Spain. Throughout this book, it is this longer "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("codo de ribera")]), _vm._v(" which we mean when we use the term "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("codo")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As this system was applied in all Spanish records up to 1750, the authors were faced with either quoting two complete sets of data, or converting the figures given in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("codos")]), _vm._v(" into later units. To allow the reader to make comparisons between vessels, we adopted the second option.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Under the Royal Ordinance issued on 25 July 1750, the use of these former units was replaced by a new system for which the basic unit was the Burgos foot (or "), _c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("pie")])]), _vm._v(") as the most constant unit of length. The "), _c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("pie")])]), _vm._v(" was exactly half the former "), _c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("codo real de Castilla")])]), _vm._v(" and thus equalled 278.635mm or 10.97 inches, or about 91.4% of the British foot ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ie")]), _vm._v(" 9.85% shorter). The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("pie")]), _vm._v(", as in the equivalent British of French systems, was divided into twelve Spanish ‘inches’ (or "), _c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("pulgadas")])]), _vm._v(", whose name literally meant ‘thumb’). The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("pulgada")]), _vm._v(" had an equivalent (as defined in 1801) of 23.219583mm, compared with the British/US inch of 25.4mm (exact). Thus the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("pulgada")]), _vm._v(" was about 91.4% of the British inch (more precisely, 91.4157%).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It might be helpful to consider both larger and small dimensions. For some purposes, a third basic unit of measurement was the Burgos yard (or "), _c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("vara")])]), _vm._v(") of 3 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("pies")]), _vm._v(". The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("vara")]), _vm._v(" equalled 835.93mm or 32.91 inches.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For longer distances, Spain used the "), _c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("milla")])]), _vm._v(" (‘mile’) and the "), _c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("legua")])]), _vm._v(" (‘league’). The Spanish "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("milla")]), _vm._v(", derived from the Roman ‘mille passus’ – or 8 stadia, was equal to 1,393 metres or 0.866 British/US miles. The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("legua")]), _vm._v(", the longest Spanish unit of measurement, equated to 3 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("millas")]), _vm._v(" or 5,000 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("varas")]), _vm._v("; it was equal to 4,180 metres or 2.597 standard British/US miles.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("pulgada")]), _vm._v(" was sub-divided into twelve "), _c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("lineas")])]), _vm._v(", each equivalent to 1.935mm (or about a thirteenth of a British inch). In theory, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("linea")]), _vm._v(" was in turn sub-divided into twelve "), _c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("puntos")])]), _vm._v(", each about 0.16mm, but this last played no part except in the measurement of the thickness of threads. In this book, we quote "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("lineas")]), _vm._v(" only as fractions of a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("pulgada")]), _vm._v(" ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("eg")]), _vm._v(" three "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("lineas")]), _vm._v(" is rendered as a quarter of a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("pulgada")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As explained above, throughout this book we converted almost all dimensions into "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("pies")]), _vm._v(" (and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("pulgadas")]), _vm._v(" where relevant). Not only were many dimensions before 1750 quoted in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("codos")]), _vm._v(", or (in the 19th century) in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("metres")]), _vm._v(", but during the English phase of construction the dimensions were recorded solely in British units. Similarly, the dimensions quoted elsewhere for the ships acquired in 1817–18 from the Russians were also recorded in British units of length. All these figures have been converted into the Spanish units to help comparisons, but with metric equivalent given in brackets.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tonnage is somewhat easier to define, as the standard "), _c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("tonelada de arqueo")])]), _vm._v(" (or Spanish measurement ton) was – like the English burthen ton – a measure of cubic capacity rather than weight. It equated to about 1.42 cubic metres. Tonnages of ships are given solely in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("toneladas")]), _vm._v(", although we use the word ‘ton’ (or the abbreviation ‘t’ after a numeral). The process used to measure this tonnage was called "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("arqueamiento")]), _vm._v(". The reader should bear in mind that the word "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("tonelada")]), _vm._v(", like the English ‘ton’, does not in itself signify whether it is a measure of weight or of cubic capacity. While a vessel’s displacement (which is a unit of weight) is infrequently recorded, we indicate this by ‘(disp.)’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("toneladas de arqueo")]), _vm._v(" are a measure of cubic capacity (or volume), we need to define units of weight in order to deal with the weight of gun projectiles and broadsides. The Spanish ton weight was equivalent to about 1,150kg; it was divided into 20 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("quintales")]), _vm._v(" (‘hundredweights’), each of 4 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("arrobas")]), _vm._v(" (‘quarters’) which were in turn each comprised of 25 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("libras")]), _vm._v(" (‘pounds’). The Spanish "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("libra")]), _vm._v(" thus equated to 0.4608kg compared with the British pound of 0.4536kg, and therefore was 1.5873% heavier; as an example 36 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("libras")]), _vm._v(" equated to 36lb 9.143oz. Obviously the weight of projectiles were in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("libras")]), _vm._v(", but for ease of reference for English-speaking "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _vm._v("readers we have used the term ‘32pdr’ when referring to a gun firing a projectile of 32 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("libras")]), _vm._v(", not of 32lbs, etc.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The metric system of weights and measures was introduced in Spain by legislation of 19 July 1849, and its application – replacing the previous system – was enshrined by a Royal Ordnance on 9 December 1852.")]), _vm._v(" "), _c('h4', {
    staticClass: "sub-section1",
    attrs: {
      "id": "lev_02"
    }
  }, [_vm._v("A NOTE ON HOW MEASUREMENTS RELATE TO VESSELS")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Where possible, we have given four principal measurements for each design of vessel, using the units of measurement described above. These are shown, where known, in the format: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("eslora, quilla")]), _vm._v(" x "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("manga")]), _vm._v(" x "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("puntal")]), _vm._v(", where:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("eslora")])]), _vm._v(" is the length of the ship measured on the lowest planked deck, inclusive of both the keel and the overhangs at both bow and stern (the extensions of the lower deck beyond the keel). Note this is not directly equivalent to the British ‘gundeck length’ and certainly not to the ship’s overall length.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("quilla")])]), _vm._v(" is the length of the straight portion of the keel, excluding the sloping portions of the keel towards the bow (the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("roda")]), _vm._v(") and towards the stern (the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("codaste")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("manga")])]), _vm._v(" is the beam of the ship, measured at its widest point at the midpoint of the length.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("puntal")])]), _vm._v(" is the depth of the hold, measured from the undersurface of the lowest continuous deck to the floor of the hold. Throughout our period, it is approximately half of the length of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("manga")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Other important dimensions which we do not give in this volume, but which can be encountered in some Spanish archives, are:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("plan")])]), _vm._v(" is the horizontal breadth of the flattened portion of the ship’s hold at its widest part.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("lanzamiento de proa")])]), _vm._v(" is the horizontal length of the forward projection of the ship’s prow beyond the front end of the keel.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("lanzamiento de la popa")])]), _vm._v(" is the horizontal length of the rearward projection of the ship’s sternpost beyond the rear end of the keel.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Note that the "), _c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("lanzamiento de proa")])]), _vm._v(" and the "), _c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("lanzamiento de la popa")])]), _vm._v(" together equalled the difference between the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("eslora")]), _vm._v(" and the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("quilla")]), _vm._v(".")]), _vm._v(" "), _c('h4', {
    staticClass: "sub-section1a",
    attrs: {
      "id": "lev_03"
    }
  }, [_vm._v("A NOTE ON NAMES")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("We have quoted the names of each Spanish vessel in full. Many vessels had two names, where the conventional name was not a religious one, as in that case a vessel would be awarded a second religious patronym (or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("advocación")]), _vm._v("). We, in common with other sources, have referred to such names as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("aliases.")]), _vm._v(" It is worth mentioning that in official communications of the navy, the prefix "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("‘San’, ‘Santa’ or ‘Nuestra Señora de’")]), _vm._v(" was often suppressed and the vessel designated solely by the remainder of the name, but for the benefit of English-speaking readers we have employed the full name throughout.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In terms of geographical locations, we have respected the multi-lingual communities that comprise the Spanish monarchy’s territory by using local names rather than Castilian ones where Castilian is not the local language. Thus we have used Gallego names for locations in Galicia, Euskara names for locations in the Basque country, and Catalan names for locations in Catalonia; one exception we have made is for the capital of the Guipúzcoa province, where we have used the better-known Castilian name of San Sebastián rather than the indigenous Donostia. However, we stress that all Spanish archives were recorded in Castilian Spanish, and all other terms used throughout this book are in that national language.")]), _vm._v(" "), _c('h4', {
    staticClass: "sub-section1",
    attrs: {
      "id": "lev_04"
    }
  }, [_vm._v("A NOTE ON DATES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("All dates in this book, where given numerically, are in the European format "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("day.month.year")]), _vm._v(", and not in the American format "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("month.day.year")]), _vm._v(", but in any date quoted in the notes at the start of each class’s entry we give the month as a word, to make it easier.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In 1582 Pope Gregory ordained a new calendar (the one we use nowadays), which was adopted immediately by Spain and other Catholic countries. This replaced the former Julian calendar (in use since 45 BC), but was not adopted by Britain (and its then colonies) until September 1752. This resulted in most dates recorded in British archives (from 1700 to 1752) being eleven days behind the dates used throughout most other European countries (the difference had been ten days in the 17th century). As an example, the Battle of Cape Passaro is recorded by the British as 31 July 1718, whereas for Spain and most other nations it was on 11 August 1718.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We have used the Gregorian (‘New Style’) dates for all events in this book, except where the building dates for ships captured from Britain are quoted, which up to 1752 are always in Julian (‘Old Style’, abbreviated to OS) dates to match British shipbuilding records. This also applies to ships built in Russia, as Russia retained the Julian calendar until the early 20th century. However, one oddity we have altered from the Julian calendar, which commenced each year on 25th March, has been to move the start of a year back to 1st January to coincide with modern practice.")]), _vm._v(" "), _c('h4', {
    staticClass: "sub-section1",
    attrs: {
      "id": "lev_05"
    }
  }, [_vm._v("A NOTE ON SPANISH NAVAL RANKS")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("The system of commissioned officer ranks in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Real Armada")]), _vm._v(" roughly paralleled those in the British and French navies, but there were significant differences. We set these ranks out below, with their equivalent titles in English. Please note the abbreviations which we have used for these ranks throughout this book, which we have shown in brackets:")]), _vm._v(" "), _c('p', {
    staticClass: "tabcap",
    attrs: {
      "id": "tab1"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Table 1: Spanish Commissioned officer ranks, abbreviations and equivalents")])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Spanish Rank")])]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Abbreviation")])]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("British Equivalent")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("Capitán General")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("CG")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Admiral")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("Teniente General")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("TG")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Vice-Admiral")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("Jefe de Escuadra")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("JdE")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Rear-Admiral")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("Brigadier")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Brig")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Commodore (or Senior Captain)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("Capitán de navío")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("CdN")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Captain")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("Capitán de fragata")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("CdF")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Commander")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("Capitán de corbeta")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("CdC")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Lieut-Commander")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("Teniente de navío")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("TdN")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Lieutenant")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("Teniente de fragata")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("TdF")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Sub-Lieutenant")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("Alférez de navío")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("AdN")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Ensign or midshipman")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("Alférez de fragata")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("AdF")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Ditto (junior)")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("The above abbreviations are used throughout this book, but in most Spanish sources the intervening ‘d’ (signifying ‘de’ or ‘of’) is omitted. Please note that the Spanish term "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Almirante")]), _vm._v(" did not signify a naval rank, but was a post – that of the second-in-commend of a fleet, the overall fleet commander being the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Capitán General.")])]), _vm._v(" "), _c('h4', {
    staticClass: "sub-section1",
    attrs: {
      "id": "lev_06"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _vm._v("A NOTE ON SPANISH MONETARY UNITS")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("During the period covered by this book, the economic health of the Spanish nation, the fiscal stability of the Spanish government and the available operational funding for Spanish naval operations were all immediately dependent on the flow of both gold and silver from Spain’s New World holdings in both South and Central America. Increases and decreases in the production of bullion and disruptions in the flow of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("azogue")]), _vm._v(" (mercury) convoys due to weather conditions or raids by corsairs or enemy naval units could and did have near catastrophic impact in Spain. During the first 150 years from 1500 to 1650, the gradual price increase for gold and silver has been calculated as six-fold. Similar figures are not available for the period from 1650 through 1808, but it was very certainly along similar lines. The slow decline in Spanish power in relation to that of her North European rivals can be attributed in large part to this process.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Before leaving this topic, it should be noted that any given value of gold or silver brought to Spain by "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("azogue")]), _vm._v(" convoys included percentage distributions between the value assigned to the Crown and that allowed for merchants doing the shipping. As is the case for all forms of taxation in all nations and at all times, there was a degree of fraud involved by the shippers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The only existing physical coins were the gold "), _c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("escudos")])]), _vm._v(" (coins of 8, 4, 2 and 1 escudos) and the silver "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("reales")]), _vm._v(" (coins of 8, 4, 2, and 1 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("reales")]), _vm._v("). As a fractional currency, and at the same time, as a unit of account, there were the "), _c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("reales de vellón")])]), _vm._v(" ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("vellón")]), _vm._v(" was an alloy of silver and copper, with silver decreasing in proportion over time).")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("The value correspondence of these coins is expressed in the attached table:")]), _vm._v(" "), _c('p', {
    staticClass: "tabcap",
    attrs: {
      "id": "tab2"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Table 2: Value equivalence of Spanish coinage.")])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Coins")])]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Value in Reales de vellon")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("8 escudos")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("320")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("4 escudos")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("160")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("2 escudos")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("  80")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("8 reales")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("  20")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("4 reales")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("  10")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("2 reales")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("    5")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The internal transactions could be made in all the previous coins while the external transactions were made only in silver.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In addition to the previous physical currencies, there were other fictional currencies: the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("peso fuerte")]), _vm._v(" and the simple peso which were the denominations used in Spanish America to designate the 20 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("reales de vellón")]), _vm._v(" (or 8 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("reales de plata")]), _vm._v(") and the 15 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("reales de vellón")]), _vm._v(", respectively.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For English language readers, it is of interest to know that the exchange rate between Spanish currency and the pound sterling at least to the end of the 18th century was 1£ = 90/100 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("reales de vellón")]), _vm._v(".")]), _vm._v(" "), _c('h4', {
    staticClass: "sub-section1a",
    attrs: {
      "id": "lev_07"
    }
  }, [_vm._v("A NOTE ON SPANISH FLAGS AND ROYAL ARMS")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("During the Habsburg era, Spanish warships flew a variety of heraldic, religious, and national flags. The primary national design was the ‘ragged cross’ or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("saltire raguly")]), _vm._v(", which consisted of two crossed green tree trunks – with the branches lopped off at intervals – on a plain white background, but with the royal arms of Spain at the centre. The royal arms consisted of a shield surmounted by a crown, the collar of the Order of the Golden Fleece, and the motto ‘Plus Ultra’ (or ‘More Beyond’), the shield itself being a complex series of emblems representing the multiple kingdoms acquired by Carlos I and his son Felipe II during the 16th century. Not only did the emblems indicate Habsburg rule in the Peninsula – Castile, Leon, Aragon and Granada (and even the annexed Portugal was represented from 1591 until 1685, long after Portuguese independence had been conceded); it also portrayed other realms, specifically Sicily, Austria, Burgundy ancient and contemporary, Brabant, Flanders and Tyrol. Later the emblems were reduced to a simplified version which contained the emblems of Castile and Leon alone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With the passing of the Habsburgs, a new royal arms was created for the incoming Bourbon dynasty, with the addition of a large central escutcheon bearing three "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("fleurs-de-lis")]), _vm._v(" (the Bourbons’ own emblem). The flags themselves were redesigned by a fresh Royal Order in 1732, which carried separate motifs for the three naval departments based on Cádiz, Ferrol and Cartagena, although all shared the common feature of the royal arms in the centre, on a white background. In 1759 the royal arms were revised to include the six blue "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("fleurs-de-lis")]), _vm._v(" of the closely-linked Farnese family (in the Duchy of Parma) and the roundels – five red and three above them blue (bearing gold "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("fleurs-de lis")]), _vm._v(") – of the Medici family (ruling the Grand Duchy of Tuscany).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In 1785 it was decided that the three departmental designs should be replaced, because the flags were too easily confused at a distance (or when obscured by battle smoke) with those of the French Royal Navy or with the White Squadron of the British Royal Navy. The new single design, created by a Royal Order on 28 May 1785, was to last – with some variations – into the present day (except during the Republican era of 1931–36). It used the Spanish national colours of red and yellow, with horizontal red stripes top and bottom (each a quarter of the flag in depth), separated by a wide yellow stripe (half the flag’s depth) on which appeared the reduced arms of Spain (specifically those emblems of Castile and Leon) surmounted by a crown. The naval jack was (and is) quite different, comprising a square flag divided into quarters, bearing the emblems of Castile, Leon, Aragon and Navarre.")]), _vm._v(" "), _c('h4', {
    staticClass: "sub-section1a",
    attrs: {
      "id": "lev_08"
    }
  }, [_vm._v("A NOTE ON CONVERSIONS")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("A problem experienced in the compilation of the 24 chapters describing the various classifications of vessels comprising the Spanish Navy has been the interesting fact that a sizeable number of vessels, most particularly those falling into the category of smaller vessels, began their careers under one classification only to have their classification changed during their careers. As a result, we have chosen to treat these converted vessels as though they were new ships, and accordingly in such rare cases have placed an entry in each of two separate sections of our work under different Chapters under their differing classifications, in contrast to the vast majority of vessels which require only a single entry. In some instances, these changes were made at early stages in the affected vessels’ careers and in others they were made at mid-points in their careers. To complicate matters, adequate descriptions of the alterations made are frequently lacking beyond the fact that the changes were authorised by Spanish naval authorities, particularly those dealing with structural alterations and armaments carried. After some consideration, the decision has been made to list here all known changes in classifications without attempting to eliminate those of too little significance to warrant their inclusion here. Cross references have been attached to all vessels included in this listing to prevent confusion in the body of the text.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As a final point of clarification, some of these vessels appear with slightly different spellings under their alternate classifications and in some cases, their gender is transformed because Spanish practices were "), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _vm._v("not uniform between different ship types ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("eg")]), _vm._v(" xebecs were always described in masculine terms while corvettes were always feminine).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With regards to the vessels included here, we have organised them on the basis of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("initial")]), _vm._v(" classification and then grouped them along the lines of our designated Chapters. In doing so, we recognise that vessels beginning their lives in one classification may well have spent the better part of their active careers in other classifications.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is our opinion that the Spanish Navy may well have been more given to this type of reclassification as a result of the wide range of environments that commissioned vessels were assigned to across the vast extent of the Spanish Empire during the period covered by this work. We leave it to the readers to form their own judgements.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Navíos")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("SANTÍSIMA TRINIDAD. Navío")]), _vm._v(" converted from 3 to 4 decks. Completed on 20.3.1769 as a 3-decker of 116 guns. Reconstructed as a 4-decker of 136 guns in 1795.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("SAN CARLOS. Navío")]), _vm._v(" converted from 2 to 3 decks. Launched as an 80-gun 2-decker in 30.4.1765. Reconstructed as a 122-gun 3-decker in 1801 and completed in 12.1804.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("RAYO. Navío")]), _vm._v(" converted from 2 to 3 decks. Completed as an 80-gun 2-decker in 15.8.1750. Reconstructed as a 100-gun 3-decker in 1804.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Small Frigates and Corvettes")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("JUPITER")]), _vm._v(". Corvette completed in 1723. Converted into a brulote in 1725.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("WINCHCOMB.")]), _vm._v(" Merchant frigate captured from the British on 3.9.1779. Converted in 1783 at Ferrol into a 6-gun urca. Decommissioned and BU in 1804.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("HÉROE.")]), _vm._v(" Corvette captured in 1781. Converted into an urca in 1787.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("CASTOR.")]), _vm._v(" British whaler captured as a light frigate in 1797. Originally renamed "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nueva Marquesa de Osorno")]), _vm._v(" in Spanish service but later renamed "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Castor")]), _vm._v(". Converted into an urca in 1814.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("LEVANTE.")]), _vm._v(" British whaling corvette "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Levant")]), _vm._v(" seized in on 23.2.1797. Converted into an urca on 16.9.1799.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Brigs and Brigantines")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("HOPP.")]), _vm._v(" Brig built in England in 1752. Acquired on 30.12.1762 and taken into Spanish service in 1763. Converted into a cutter on 20.10.1779.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("SAN CARLOS")]), _vm._v(". Brig launched on 12.12.1772. Converted into a packet in 1773.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("PERUANO")]), _vm._v(". Brig completed at Cartagena del Limeño in 1793. Converted into a corvette on 25.8.1805.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("BATIDOR.")]), _vm._v(" Brig "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Batidor")]), _vm._v(" launched in 1796 acquired from the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Correos Maritimos")]), _vm._v(" (Postal Service) in 1802 to serve as an aviso. Converted into a corvette designated as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Batidora")]), _vm._v(" in early 1803.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("AMISTAD.")]), _vm._v(" Brig completed in 1799. Converted into a corvette in 1804.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("GÁLVEZ.")]), _vm._v(" Brig first mentioned at Montevideo in 1811. Rearmed on 2.11.1813 as a zumaca")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("PARANÁ")]), _vm._v(", 18 guns. Prize Argentinian insurgent brig "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Our Lady of Caldas")]), _vm._v(" taken on 2.3.1811. Reclassified as a brig-zumaca on 23.9.1811. Recaptured by insurgents in 1814.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("LIGERO.")]), _vm._v(" Brig purchased by the Consulate of Lima on 15.2.1816 on 14.4.1817. Converted into a brig-schooner on 14.4.1817.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("PROVIDENCIA.")]), _vm._v(" Brig-schooner first mentioned as departing Puerto Cabello on 9.11.1816. Converted into a schooner on 28.2.1817.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("CAUTIVO")]), _vm._v(". Insurgent Colombian brig "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Liberal.")]), _vm._v(" Captured on 12.2.1828 and designated as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Cautivo")]), _vm._v(" in Spanish service. Converted into a corvette designated as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Cautiva")]), _vm._v(" on 28.2.1829.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Bomb Vessels")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Santa Eulalia")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Santa Casilda")]), _vm._v(" were a pair of 10-gun bomb vessels completed on 17.3.1775. Converted into 2-masted 18-gun packets in 1787 after having been first proposed as 3-masted corvettes. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Santa Eulalia")]), _vm._v(" ultimately converted from a packet into a fireship. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Santa Eulalia")]), _vm._v(" last mentioned in 1802. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Santa Casilda")]), _vm._v(" put up for sale on 19.6.1813 but scrapped without buyers at La Carraca on 30.7.1813.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Storeships (Urcas)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ABASCAL")]), _vm._v(". Merchant brig completed in Dalmatia in 1805 as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Amable María")]), _vm._v(" and classified as an urca designated as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Abascal")]), _vm._v(" in Spanish service with the advocation of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nuestra Señora de Covadonga")]), _vm._v(". Converted into a corvette designated as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Abasca")]), _vm._v("l in 2.1812.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Fireships")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("TRUCHESTER.")]), _vm._v(" Prize captured in 1780. Classified on 7.8.1780 as a fireship and reclassified as a brigantine on 25.10.1780.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Packets")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("JÚPITER.")]), _vm._v(" Lead ship of a class of packets built at La Carraca on 2.4.1753. Converted into a small frigate by 1769.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("SAN GIL.")]), _vm._v(" Packet completed in 1777. Converted into a corvette in 1782.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("SAN PIO.")]), _vm._v(" Packet completed in 1777. Converted into a corvette in 1782.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("NUESTRA SEÑORA DE ARÁNZAZU")]), _vm._v(". Packet constructed in 1779. Reclassified as a frigate when lengthened by 7ft in 1788.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Polacres and Zumacas")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ARÁNAZU.")]), _vm._v(" Zumaca stationed at the Rio de Plata in 1809. Last mentioned in 1816 as a brig.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Galleys")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("SANTO CRISTO.")]), _vm._v(" Xebec completed at Havana in 1780. Converted into a brig at Havana on 3.2.1784. Stricken as unsuitable on 25.1.1786.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Xebecs")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("SAN SEBASTIÁN.")]), _vm._v(" 18-gun xebec laid down on 12.3.1774 at Cartagena. Rerigged as 24-gun corvette "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sebastiana")]), _vm._v(" in 1809. Disarmed in 2.1818. Stricken at El Callao in 1822.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("MURCIANO.")]), _vm._v(" 22-gun xebec launched in 1779. Converted between 1804 and 1808 into a corvette designated as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Murciana.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("SANTO CRISTO")]), _vm._v(". 30-gun xebec built in Havana in 1780. Found unsuitable and converted into a brig at Havana on 3.2.1784. Found unsuitable as a brig and stricken on 25.1.1786")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Barks and Misticos")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ÁGUILA.")]), _vm._v(" Mistico constructed in Barcelona in 1845. Converted into a brig-schooner at La Carraca on 12.9.1850. Last mentioned in 1853")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Feluccas")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("RESISTENCIA")]), _vm._v(". Felucca first reported as operating against Venezuelan insurgents in Costa Firme on 8.4.1815. Converted into a mistico at Cumaná on 9.11.1816. Lost at the battle on Lake Maracaibo on 23.7.1823.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Schooners")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("SAN GREGORIO TAUMATURGO")]), _vm._v(", 14 guns. Schooner first mentioned on 3.12.1786. Referred to as a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("balajú")]), _vm._v(" operating in Cartagena de Indias between 1794 and 1799. Last mentioned in the EGA in 1808")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("SUTIL")]), _vm._v(". Schooner completed in 10/11.1791 and later converted into a brig. Last mentioned in 1798.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ACTIVA")]), _vm._v(", 10 guns. Schooner "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Activa")]), _vm._v(" launched on 1.1792. Believed to have been converted into a brig designated as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Activo.")]), _vm._v(" Last mentioned on 21.10.1815. Incorporated into the Mexican Navy in 7.1821.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ALAVESA.")]), _vm._v(" Schooner "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Alavesa")]), _vm._v(" completed in 1802. Converted into a brig designated as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Alavés")]), _vm._v(" at Callao in 12.1808.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ANDALUZA.")]), _vm._v(" 18-gun schooner built for the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Carrera de Indias")]), _vm._v(" on 23.6.1804 as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nuestra Señora de las Mercedes.")]), _vm._v(" Designated as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Andaluza")]), _vm._v(" in Spanish service. Converted into a brig also designated as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Andaluza")]), _vm._v(" in 8.1805.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("BELONA.")]), _vm._v(" Former 4-gun schooner purchased by private collection by business interests in Veracruz in 5.1817. Formally assigned in Havana as replacement for the brig "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Marte")]), _vm._v(" on 6.2.1822. Converted into a 16-gun brig-schooner in 1823. Sold on 21.12.1827.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("SORPRESA")]), _vm._v(" Class of four schooners was ordered from Bordeaux on 20.6.1819 All four vessels were converted into brig-schooners by no later than 1823: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sorpresa, Mágica, Diligente, Encantadora")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("MAHONESA.")]), _vm._v(" Schooner "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mahonesa")]), _vm._v(" completed in 1821. Converted into a brig-schooner in 1847 and renamed "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ebro.")]), _vm._v(" Last mentioned in 1855.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Pailebotes and Balajús")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ZELOSO")]), _vm._v(" -Balajú completed on 4.8.1804. Converted into a brig on 17.3.1809.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("SAN CARLOS")]), _vm._v(" 10 guns -Balajú first mentioned at Havana on 11.7.1783. Put up for sale as a schooner due to deteriorated condition on 25.1.1786.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("DON QUIJOTE (EL AVENTURERO)")]), _vm._v(" - Balajú taken as a 12-gun prize on 12.3.1785 in the Rio Azúcar by the schooner "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chula")]), _vm._v(". Designated also as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("El Aventurero")]), _vm._v(" to distinguish vessel from a contemporary galley with the same name. Sold as a 16-gun schooner at Cartagena de Indias on 27.1.1790.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Balandras")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("NUESTRA SEÑORA DE ATOCHA.")]), _vm._v(" Completed as a balandra (cutter) launched on 16.12.1780. Converted into a brig in 10.1781.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("RESOLUCIÓN")]), _vm._v(". British balandra (cutter) captured in 1780. Converted into a brig on 5.4.1793.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("TÁRTARO")]), _vm._v(". British balandra (cutter) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tartar")]), _vm._v(" seized in 1781. Converted into a brig on 11.12.1794.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("GALLEGA")]), _vm._v(" Class of balandras (cutters) were originally built at Ferrol in 1797 and 1799 respectively and converted into schooners in 1808: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gallega (Santa Polonia), Brava (Santa Engracia)")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("PENÉLOPE")]), _vm._v(". Balandra (cutter) seized from the British on 9.7.1799. Commissioned as a brig for coastguard duties between Caracas and Puerto Cabello on 22.11.1803.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-734f422e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/08_Some.vue
// module id = 81
// module chunks = 0